import React, { useMemo } from 'react'
import SonarqubeCredentialsForm from './SonarqubeCredentialsForm';
import GenericPullConfigListing from '../GenericPullConfigListing';
import { useFeatureFlag } from 'contexts/FeatureFlagContext';
import _, { map } from 'lodash';
import {CellRenderers, columnRenderArrayData} from "utils/tableUtils";
import SonarqubeMappingFormV2 from './SonarqubeMappingFormV2';

export default function SonarqubeConfigListing(props) {
    const featureFlags = useFeatureFlag();

    const columns = useMemo(() => [{
        title: "Component",
        render: (record) => {
            if(featureFlags.SONARQUBE_COMPONENT_NAME_WITH_KEY){
                if(_.isNull(record["componentNameWithKey"])){
                    let componentDisplayNameList = record["componentDisplayName"]?.split(",");
                    let componentNameList = record["componentName"]?.split(",");
                    let project = componentDisplayNameList.map((item, index) => `${item}/${componentNameList[index]}`);

                    const renderName = project.join(",");
                    return columnRenderArrayData(renderName);
                }
                else{
                    return columnRenderArrayData(record["componentNameWithKey"])
                }
            }
            else{
                return columnRenderArrayData(record["componentDisplayName"])
            }
        },
        width: 200
    }, 
    {
        title: "Branch",
        dataIndex: "componentNameWithBranch",
        render: (componentNameWithBranch) => {
            if(componentNameWithBranch){
                return columnRenderArrayData(getBranchValues(componentNameWithBranch, true).join());
            } else {
                return CellRenderers.VALUE_OR_NA()
            }
        },
        width: 200,
    }
    ], [featureFlags.SONARQUBE_COMPONENT_NAME_WITH_KEY]);

    return (
        <GenericPullConfigListing
            {...props}
            toolName={props.name}
            MappingForm={SonarqubeMappingFormV2}
            CredentialsForm={SonarqubeCredentialsForm}
            extraColumns={columns}
        />
    )
};

export const getBranchValues= (componentNameWithBranch, displayNA = false) => map(Object.keys(JSON.parse(componentNameWithBranch)), (item) => {
    const emptyDisplay = displayNA ? CellRenderers.VALUE_OR_NA() : undefined;
    const branch = JSON.parse(componentNameWithBranch)[item]
    return branch ? branch : emptyDisplay
});